import { CsiImage, Text } from "designSystem/index";
import React from "react";
import CssColumnGrid from "../../CssColumnGrid";
import imageLS from "./LandscapeSmallImage.jpg";
import imageLT from "./LandscapeThumbnail.jpg";
import imagePS from "./PortraitSmallImage.jpg";
import imagePT from "./PortraitThumbnail.jpg";

export default () => {
	return (
		<CssColumnGrid columns={4}>
			<Text semiBold text="landscape (small)" />
			<Text semiBold text="landscape (large)" />
			<Text semiBold text="portrait (small)" />
			<Text semiBold text="portrait (large)" />
			<CsiImage size="small" src={imageLT} />
			<CsiImage size="small" src={imageLS} />
			<CsiImage size="small" src={imagePT} />
			<CsiImage size="small" src={imagePS} />
		</CssColumnGrid>
	);
};